// extracted by mini-css-extract-plugin
module.exports = {"blur":"App_blur_1Dtg2","relative":"App_relative_1_piR","hasLeftMenu":"App_hasLeftMenu_kq2mI","hasHeader":"App_hasHeader_UB1DN"};